import { DoqFaceSvgProps } from '../types';

const Locked = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1405_41494)">
      <g clipPath="url(#clip1_1405_41494)">
        {/* mask to hide the bottom outline of the circle */}
        <mask id="bottom-mask-locked">
          <circle cx="160" cy="160" r="160" fill="white" />
          <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
        </mask>
        <circle
          cx="160"
          cy="160"
          r="160"
          fill="#8800FF"
          mask="url(#bottom-mask-locked)"
        />

        <mask
          id="mask0_1405_41494"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
        </mask>
        <g mask="url(#mask0_1405_41494)">
          <rect x="80" y="120" width="160" height="200" fill="white" />
        </g>
        <path
          d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
          fill="#2974C4"
        />
        <path
          d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
          fill="#2974C4"
        />
        <circle cx="178" cy="177" r="15" fill="#D9DEE3" fillOpacity="0.5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M192.89 188.804C189.409 193.188 184.033 196 178 196C167.507 196 159 187.493 159 177C159 166.507 167.507 158 178 158C188.493 158 197 166.507 197 177C197 177.51 196.98 178.015 196.941 178.514C196.981 178.677 197.002 178.847 197 179.022L196.5 223.522C196.487 224.627 195.582 225.512 194.478 225.5C193.373 225.487 192.488 224.582 192.5 223.478L192.89 188.804ZM193 177C193 185.284 186.284 192 178 192C169.716 192 163 185.284 163 177C163 168.716 169.716 162 178 162C186.284 162 193 168.716 193 177Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M240 248H80V254H140.094C140.472 257.997 141.969 261.667 144.27 264.695C143.869 265.336 143.538 266.036 143.293 266.787C141.971 270.833 143.54 275.083 146.81 277.431L142.826 289.622L144.65 293.216L151.839 289.569L150.015 285.974L153.609 284.151L151.786 280.556L152.228 279.202C156.15 279.237 159.836 276.862 161.246 272.999C161.618 272.994 161.988 272.98 162.356 272.957C163.132 275.453 165.11 277.411 167.6 278.2V289L170 291.4L174.8 286.6L172.4 284.2L174.8 281.8L172.4 279.4V278.2C175.632 277.176 178 274.184 178 270.6C178 268.918 177.48 267.356 176.592 266.068C179.534 262.809 181.469 258.622 181.906 254H240V248ZM161.822 269.982C161.889 269.979 161.957 269.975 162.024 269.971C162.345 265.849 165.796 262.6 170 262.6C171.649 262.6 173.182 263.1 174.456 263.956C176.866 261.245 178.47 257.801 178.89 254H143.11C143.453 257.103 144.585 259.968 146.3 262.391C148.725 260.408 152.078 259.664 155.274 260.708C159.36 262.044 161.927 265.892 161.822 269.982ZM149.545 265.885C150.734 265.03 152.301 264.734 153.798 265.223C155.745 265.859 157.001 267.635 157.071 269.57C154.257 268.943 151.692 267.659 149.545 265.885ZM147.788 268.324C150.212 270.288 153.081 271.723 156.221 272.454C155.054 274.129 152.887 274.92 150.847 274.253C148.375 273.445 147.016 270.799 147.788 268.324ZM170 274.6C168.401 274.6 167.021 273.661 166.381 272.304C169.02 271.607 171.456 270.408 173.581 268.816C173.849 269.353 174 269.959 174 270.6C174 272.808 172.208 274.6 170 274.6ZM166.243 269.224C168.048 268.676 169.733 267.851 171.249 266.799C170.856 266.67 170.436 266.6 170 266.6C168.275 266.6 166.804 267.693 166.243 269.224Z"
          fill="#5094DC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M159 208C153.078 208 147.907 204.783 145.141 200L150.056 200C152.253 202.455 155.446 204 159 204C162.554 204 165.747 202.455 167.944 200L172.859 200C170.093 204.783 164.922 208 159 208Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1405_41494">
        <rect width="320" height="320" fill="white" />
      </clipPath>
      <clipPath id="clip1_1405_41494">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Locked };
